<script>
import BaseForm from '@/model/baseForm/BaseForm/BaseForm.vue'
import LoadingProvider from '@/views/widget/LoadingProvider.vue'
import { getMembershipSystem, updateMembershipSystem } from '@/model/dataLayer/api/MembershipSystem/MembershipSystem'
import { showSuccessMessage } from '@/model/utils/utils'

export default {
  name: 'PointRuleForm',
  components: {
    LoadingProvider,
    BaseForm
  },
  props: {
    systemInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      saveLoading: false,
      localSystemInfo: {
        pointRule: {
          pointsPerUnit: 0,
          minimumSpend: 0,
          maxPointsPerTransaction: 0,
          expirationDays: 0
        }
      }
    }
  },
  watch: {
    systemInfo: {
      immediate: true,
      deep: true,
      handler (val) {
        if (val && Object.keys(val).length > 0) {
          // Deep merge to ensure all nested properties are preserved
          const deepCopy = JSON.parse(JSON.stringify(val))

          // Ensure pointRule exists
          if (!deepCopy.pointRule) {
            deepCopy.pointRule = this.localSystemInfo.pointRule
          }

          this.localSystemInfo = deepCopy
        }
      }
    }
  },
  async mounted () {
    if (!this.systemInfo || Object.keys(this.systemInfo).length === 0) {
      await this.reload()
    }
  },
  computed: {
    fullSchema () {
      return [
        // Point Rule Section
        {
          key: 'pointRule.pointsPerUnit',
          name: 'pointsPerUnit',
          hint: '每欧元获得积分',
          required: false,
          default: 0
        },
        {
          key: 'pointRule.minimumSpend',
          name: 'minimumSpend',
          hint: '最低消费金额',
          required: false,
          default: 0
        },
        {
          key: 'pointRule.maxPointsPerTransaction',
          name: 'maxPointsPerTransaction',
          hint: '每笔交易最大积分',
          required: false,
          default: 0
        },
        {
          key: 'pointRule.expirationDays',
          name: 'expirationDays',
          hint: '积分过期天数',
          required: false,
          default: 0
        }
      ]
    }
  },
  methods: {
    async reload () {
      this.loading = true
      const systemData = await getMembershipSystem()

      // Ensure the required nested objects exist
      if (!systemData.pointRule) {
        systemData.pointRule = {
          pointsPerUnit: 0,
          minimumSpend: 0,
          maxPointsPerTransaction: 0,
          expirationDays: 0
        }
      }

      this.localSystemInfo = systemData
      this.$emit('update:system-info', this.localSystemInfo)
      this.loading = false
    },
    async submit (info) {
      this.saveLoading = true
      try {
        // Ensure the required nested objects exist
        if (!info.pointRule) {
          info.pointRule = {
            pointsPerUnit: 0,
            minimumSpend: 0,
            maxPointsPerTransaction: 0,
            expirationDays: 0
          }
        }

        // If we're in standalone mode, save directly
        if (!this.systemInfo || Object.keys(this.systemInfo).length === 0) {
          await updateMembershipSystem(info)
        }

        // Emit the updated info to the parent
        this.$emit('update:system-info', info)
        showSuccessMessage('保存成功！')
      } catch (error) {
        console.error('Error updating system:', error)
      } finally {
        this.saveLoading = false
      }
    }
  }
}
</script>

<template>
  <div>
    <loading-provider :loading="loading">
      <!-- Point Rule Form with fixed height and scrolling -->
      <div class="form-container">
        <base-form
          :color="'#fefefe'"
          :editing-object="localSystemInfo"
          :is-dialog="false"
          :schema="fullSchema"
          :loading="saveLoading"
          class="pa-4"
          @submit="submit"
        >
          <div>积分规则设置</div>
          <template #subtitle>
            在这里修改会员系统的积分规则设置
          </template>
        </base-form>
      </div>
    </loading-provider>
  </div>
</template>

<style scoped>
.form-container {
  max-height: calc(100vh - 120px); /* Adjust the value as needed to fit your layout */
  overflow-y: auto;
  border-radius: 4px;
}
</style>
